export { default as CodeEmbed } from './CodeEmbed';
